export const getUpdateStudentData = state => {
  const {
    updateStudent: { data },
  } = state
  return { data }
}

export const getUpdateStudentStatusProps = state => {
  const {
    updateStudent: { fetching, fetched, submitting, submitted, error },
  } = state
  return { fetching, fetched, submitting, submitted, error }
}
